"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DIRECTOR_SESSION = void 0;
var DIRECTOR_SESSION = exports.DIRECTOR_SESSION = 'directorSession';